/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JsonUserData
 */
export interface JsonUserData {
    /**
     * 
     * @type {Array<number>}
     * @memberof JsonUserData
     */
    favouriteOnepagerIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof JsonUserData
     */
    recentOnepagerIds?: Array<number>;
}

export function JsonUserDataFromJSON(json: any): JsonUserData {
    return JsonUserDataFromJSONTyped(json, false);
}

export function JsonUserDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonUserData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'favouriteOnepagerIds': !exists(json, 'favouriteOnepagerIds') ? undefined : json['favouriteOnepagerIds'],
        'recentOnepagerIds': !exists(json, 'recentOnepagerIds') ? undefined : json['recentOnepagerIds'],
    };
}

export function JsonUserDataToJSON(value?: JsonUserData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'favouriteOnepagerIds': value.favouriteOnepagerIds,
        'recentOnepagerIds': value.recentOnepagerIds,
    };
}

